import { Component, OnInit } from "@angular/core";
import { interval, Subscription } from "rxjs";
import { NetworkDetails } from "src/app/core/models/hostNetworkDetails";
import { HealthService } from "src/app/core/services/health.service";
import { SyncConfigService } from "src/app/core/services/sync-config.service";

@Component({
  selector: "app-health-network",
  templateUrl: "./health-network.component.html",
  styleUrl: "./health-network.component.scss",
})
export class HealthNetworkComponent implements OnInit {
  constructor(
    private healthService: HealthService,
    public syncConfig: SyncConfigService
  ) {}
  dataReloadSubscription: Subscription;
  networkDetails: NetworkDetails;
  ngOnInit(): void {
    this.getHostNetworkDetails();
    this.startDataReloadSub();
  }

  getHostNetworkDetails() {
    this.healthService.getHostNetworkDetails().subscribe({
      next: (data: any) => {
        this.networkDetails = <NetworkDetails>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  startDataReloadSub() {
    this.dataReloadSubscription = interval(
      this.syncConfig.config.healthService.dataReqInterval
    ).subscribe(async () => {
      await this.getHostNetworkDetails();
    });
  }
}
